export default {
    SET_SEARCH_FILTER(state, payload){
        state.searchFilter = payload;
    },
    CLEAR_SERACH_FILTER(state){
        state.searchFilter = null;
    },
    SET_MODE(state) {
        state.mode = !state.mode
    },
}